import { useAuthContext } from "../../auth/context/auth-context";

const useAuth = () => {
  return useAuthContext();
};

export default useAuth;
